class PostTeaserCreate
    constructor: (options) ->
        @.$el = null

        @.atText = options?.atText ? 'am'
        @.attrs = options?.attrs ? false
        @.kicker = options?.kicker ? 'Thema'
        @.lastPostText = options?.lastPostText ? 'Letzter Beitrag'
        @.link = options?.link ? false
        @.postTime = options?.postTime ? false
        @.profilePic = options?.profilePic ? {}
        @.tag = options?.tag ? 'div'
        @.title = options?.title ? 'Titel'
        @.userName = options?.userName ? false
        
        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'post-teaser'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.link
            @.$el.appendChild new KebabButtonCreate {
                attrs: {
                    class: ['post-teaser__kebab']
                },
                link: @.link
            }
        @.$el.innerHTML += "
            <div class='kicker post-teaser__kicker'>#{ @.kicker }</div>
            <h4 class='headline headline--4 post-teaser__title'>#{ @.title }</h4>
        "
        if @.postTime && @.userName
            @.$el.innerHTML += "
                <div class='post-teaser__info'>
                </div>
            "
            @.profilePic.onWhite = true
            @.profilePic.small = true
            @.$el.querySelector '.post-teaser__info'
                .appendChild new ProfilePicCreate @.profilePic
            @.$el.querySelector '.post-teaser__info'
                .innerHTML += "
                    <div class='post-teaser__last-post'><span>#{ @.lastPostText }:</span>#{ @.userName }<span>#{ @.atText }</span>#{ @.postTime }</div>
                "
        return

window.CreatePostTeaser = (options) ->
    return new PostTeaserCreate options